var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('div', {
    staticClass: "activity-id-label"
  }, [_c('p', [_vm._v("Activity ID")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.activityId,
      expression: "activityId"
    }],
    staticClass: "activity-id",
    attrs: {
      "type": "text",
      "name": "activity-id"
    },
    domProps: {
      "value": _vm.activityId
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.activityId = $event.target.value;
      }
    }
  }), _c('button', {
    staticClass: "activity-id-go",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.launchByActivityId();
      }
    }
  }, [_vm._v("\n      GO\n    ")])]), _c('div', {
    staticClass: "activity-variants"
  }, [_c('h2', [_vm._v("Activity Variants")]), _c('ul', _vm._l(_vm.kwtActivities, function (item) {
    return _c('li', {
      key: item.variant,
      staticClass: "newJson",
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.launchByActivityTypeVariant(item.variant);
        }
      }
    }, [_c('button', [_vm._v("\n          " + _vm._s(item.displayName) + "\n          "), _c('span', [_vm._v(_vm._s(item.variant))])])]);
  }), 0)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }